const CSV_COLUMNS = [
  "created_at", "status", "lead_tier", "lead_score", "org_name", "industry", "org_type", "hq_city_state", "num_employees", "website", "it_budget",
  "full_name", "title_role", "email", "phone", "preferred_contact", "services", "cloud_providers", "security_stack",
  "rmm_tools", "network_summary", "num_locations", "num_endpoints", "compliance", "business_drivers",
  "desired_outcomes", "target_start", "decision_timeline", "budget_range", "additional_notes", "printed_name",
  "inquiry_type", "service_address", "num_sites", "desired_speed", "tv_requirements", "current_provider",
];

const escapeCell = (v) => {
  const s = Array.isArray(v) ? v.join("; ") : v == null ? "" : String(v);
  return `"${s.replace(/"/g, '""')}"`;
};

export const toCsv = (rows) => {
  const header = CSV_COLUMNS.join(",");
  const lines = rows.map((r) => CSV_COLUMNS.map((c) => escapeCell(r[c])).join(","));
  return [header, ...lines].join("\n");
};

export const downloadCsv = (rows) => {
  const blob = new Blob([toCsv(rows)], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = `silent-sentry-inquiries-${new Date().toISOString().slice(0, 10)}.csv`;
  a.click();
  setTimeout(() => URL.revokeObjectURL(url), 0);
};
